import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";

import { Button } from "@transfr-inc/dashboard-components/forms";

import "./error.scss";

const defaultOptions = {
  image: "/images/misc/error.png",
  title: "Page failed to load.",
  message:
    "Don't worry, every great adventure has a few wrong turns. Try again to get back on course. ",
  buttonLabel: "Reload Page",
};

export const ErrorPage = ({ options, onClick, children }) => {
  const { image, title, message, buttonLabel } = {
    ...defaultOptions,
    ...options,
  };

  const location = useLocation();
  const previousLocation = useRef(location?.key);
  const { resetBoundary } = useErrorBoundary();

  const onClickHandler = () => {
    resetBoundary();
    onClick?.();
  };

  useEffect(() => {
    // Workaround to reset the error boundary when the location
    // really changes, not just refreshing the page.
    // The resetBoundary function does that for us.
    if (location?.key !== previousLocation.current) {
      resetBoundary();
    }
  }, [location]);

  return (
    <div className="error-page">
      <div className="error-page-content">
        <div className="error-page-header">
          <img src={image} alt="error" />
        </div>
        <div className="error-page-body">
          {children ? (
            children
          ) : (
            <>
              <div className="error-page-message">
                <h2>{title}</h2>
                <p>{message}</p>
              </div>
              <div className="error-page-actions">
                <Button primary onClick={onClickHandler}>
                  {buttonLabel}
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  actions: PropTypes.node,
  onClick: PropTypes.func,
  options: PropTypes.object,
  children: PropTypes.node,
};
